import React, {Component} from 'react';
import PropTypes from "prop-types";


class BooleanCellRender extends Component {

  render() {
    return (
      <input type="checkbox" readOnly={true} checked={this.props.value} />
    )
  }
}

BooleanCellRender.propTypes = {
  value: PropTypes.any,
};

export default BooleanCellRender;